/// <reference path="../types.d.ts" />

import { createReducer } from '@reduxjs/toolkit';
import InitialState from '../reducers/initial-state';
import * as analytics from '../actions/analytics';
import { refreshContext } from '../actions/contexts.action';
import { LOAD_STATES } from './common';
import { configAvailable } from '../actions/ui';
import * as UIActions from '../actions/ui';
import { jumpContext } from '../actions/contexts.action';

const reducer = createReducer(InitialState.analytics, (builder) => {
  builder.addCase(UIActions.logout.type, () => ({ ...InitialState.analytics }));
  builder.addCase(jumpContext.pending.type, () => ({ ...InitialState.analytics }));

  builder.addCase(analytics.instantiateDashboard, state => ({
    ...state,
    loadState: LOAD_STATES.started
  }));

  builder.addCase(configAvailable, (state, action) => ({
    ...state,
    tableauInfo: (action as any).payload.tableauInfo
  }));

  builder.addCase(refreshContext.pending.type, state => ({ ...state }));
  builder.addCase(analytics.fetchTableauToken.pending, state => ({ ...state }));

  builder.addCase(analytics.fetchTableauToken.rejected, state => ({
    ...state,
    loadState: LOAD_STATES.failed
  }));

  builder.addCase(analytics.fetchTableauToken.fulfilled, (state, action) => ({
    ...state,
    tableauToken: action.payload
  }));

  builder.addCase(analytics.setActiveDashboard, (state, action) => ({
    ...state,
    activeDashboard: action.payload
  }));

  builder.addCase(analytics.setActiveDashboardResource, (state, action) => ({
    ...state,
    activeDashboardResource: action.payload
  }));

  builder.addCase(analytics.getSubNavPaths.fulfilled, (state, action) => {
    const configurationValues = action.payload ?? [];
    const dashboardPaths: { [key: string]: string } = {};
    configurationValues.sort((a: any, b: any) => a.id - b.id);

    configurationValues.forEach((configVal: any) => {
      if (configVal.values?.length) {
        dashboardPaths[configVal.values[0].configurationKeyname] =
          configVal.values[0].value;
      }
    });
    return {
      ...state,
      dashboardPaths,
      activeDashboardResource:
        configurationValues[0]?.values[0]?.configurationKeyname
    };
  });
});

export default reducer;
